import React from 'react';
import {RouteObject} from 'react-router-dom';

import * as factories from 'main/factories/pages';
import {BeneficiariesRoute, PlanRoute} from 'main/proxies/inter-routes';
import {FacialBiometricsWrapper, SelectionFlow} from 'presentation/pages';
import {FacialBiometricEnum, SelectionFlowEnum} from 'presentation/constants';

export function getOtherRoutes() {
	const otherRoutes: RouteObject[] = [
		{
			element: <SelectionFlow />,
			children: [
				{
					element: <PlanRoute />,
					children: [
						{
							path: SelectionFlowEnum.PLAN_SELECTION,
							element: <factories.MakePlanSelection />,
						},
					],
				},
				{
					element: <BeneficiariesRoute />,
					children: [
						{
							path: SelectionFlowEnum.BENEFICIARY_SELECTION,
							element: <factories.MakeBeneficiarySelection />,
						},
						{
							path: SelectionFlowEnum.CONFIRM_SELECTION,
							element: <factories.MakeConfirmSelection />,
						},
					],
				},
			],
		},
		{
			element: <FacialBiometricsWrapper />,
			children: [
				{
					path: FacialBiometricEnum.FACIAL_BIOMETRIC,
					element: <factories.MakeInitialInstructions />,
				},
				{
					path: FacialBiometricEnum.FACE_PHOTO,
					element: <factories.MakeFacePhoto />,
				},
				{
					path: FacialBiometricEnum.DOCUMENT_PHOTO,
					element: <factories.MakeDocumentPhoto />,
				},
				{
					path: FacialBiometricEnum.SUCCESS,
					element: <factories.MakeSuccess />,
				},
			],
		},
	];

	return otherRoutes;
}
